//#region import
import React from "react";
//styles
import { Colors, Spacing } from '_styles';
//icons
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChevronLeft, faChevronRight } from '@fortawesome/free-solid-svg-icons'
//#endregion

const Clicker = (props) => {
    return (
        <div style={{ display: 'flex', flexDirection: 'row' }}>
            {/* previous */}
            <div style={{ cursor: 'pointer', opacity: props?.disabledDate === true ? 0.5 : 1 }}>
                <FontAwesomeIcon icon={faChevronLeft} size={18} color='#307FE2' onClick={props.onClickPrevious} />
            </div>
            {/* month */}
            <div style={props?.textStyle ? props?.textStyle : { minWidth: "200px" }}>

                <p style={{ fontSize: 25, fontWeight: 'lighter', textAlign: "center", color: Colors.TEXT_COLOR, marginTop: -Spacing.SCALE_8 }}>{props.text}</p>
            </div>
            {/* next */}
            <div style={{ cursor: 'pointer' }}>
                <FontAwesomeIcon icon={faChevronRight} size={18} color='#307FE2' onClick={props.onClickNext} />
            </div>

        </div>
    );
}

export default Clicker;